import { useState } from 'react';
import AddPost from './add-post';
import ShowPost from './show-post';
import weathericon from './../../../assets/home/newsfeed/weathericon.png'

const Newsfeed = () => {
  const [convertedContent, setConvertedContent] = useState<any>("");
  const [addData, setAddData] = useState<any>(false);

  return (
    <>
    <div>
      <div className='d-flex'>
        <h2 className='h2 what-happening'>What’s happening</h2>
        <img style={{paddingLeft: "20px"}} src={weathericon} alt="" />
      </div>
      <AddPost setConvertedContent={setConvertedContent} setAddData={setAddData} />
      <ShowPost convertedContent={convertedContent} addData={addData} />
      </div>
    </>
  )
}

export default Newsfeed